import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=3af5b05b"
import script from "./Breadcrumb.js?vue&type=script&lang=js&external"
export * from "./Breadcrumb.js?vue&type=script&lang=js&external"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=3af5b05b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports